<template>
  <div class="content">
    <v-form lazy-validation v-model="valid">
      <div>
        <p>
          <label for="password1">Insert your new password</label>
        </p>
        <p>
          <v-text-field
            v-model="credentials.password1"
            id="password1"
            type="password"
            :rules="insertPassword"
            label="Password"
          ></v-text-field>
          <v-text-field
            v-model="credentials.password2"
            id="password2"
            type="password"
            label="Repeat password"
            :rules="repeatPassword"
          ></v-text-field>
        </p>
      </div>
      <v-btn
        v-if="!loading"
        type="submit"
        variant="primary"
        @click="confirmNewPassword"
        >Reset password</v-btn
      >
      <SmallLoaderLight class="form-loader" v-if="loading" />
    </v-form>
    <div v-if="response" class="response glass-element">
      <h3>{{ response.data.detail }}</h3>
      <Loader v-if="loading" />
    </div>
    <v-btn class="signup-link"
      ><router-link to="/login">Login</router-link></v-btn
    >
  </div>
</template>

<script>
import { httpRequest } from "@/services";
import Loader from "@/components/atoms/Loader";

export default {
  components: { Loader },
  data() {
    return {
      loading: false,
      response: null,
      insertPassword: [(v) => !!v || "Password cannot be empty"],
      repeatPassword: [
        (v) => !!v || "Password cannot be empty",
        (v) => v == this.credentials.password1 || "Passwords do not match",
      ],

      credentials: {
        password1: null,
        password2: null,
      },
    };
  },
  methods: {
    async confirmNewPassword() {
      this.loading = true;
      this.response = null;
      let newPassword = {
        new_password1: this.credentials.password1,
        new_password2: this.credentials.password2,
        uid: this.$route.params.uid,
        token: this.$route.params.token,
      };
      this.response = await httpRequest(
        "post",
        "rest-auth/password/reset/confirm/",
        newPassword
      );
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.content {
  margin: 100px;
}

.response {
  padding: 12px 24px;
}

button {
  margin: 42px 0;
}
</style>